import * as React from "react";
import { Link as RouterLink } from "react-router-dom";
import clsx from "clsx";

import { ListResultsMeta } from "services/api/shared";
import {
  Button,
  Pagination,
  DataTable,
  ResponsiveTableWrapper,
  LoadingPlaceholder
} from "components";
import { ListFiltersState } from "utils/hooks/useListFilters";
import useStyles from "components/data-table/data-table.styles";
import { CompanyItem } from "modules/companies/provider/companies";

import GroupListToolbar from "./group-list-toolbar.component";

type Props = {
  groups: CompanyItem[];
  meta: ListResultsMeta;
  listFilters: ListFiltersState;
  loading: boolean;
};

const GroupList: React.FC<Props> = ({ groups, meta, listFilters, loading }) => {
  const classes = useStyles();
  return (
    <>
      <GroupListToolbar listFilters={listFilters} />
      {loading ? (
        <LoadingPlaceholder />
      ) : (
        <>
          <ResponsiveTableWrapper>
            <DataTable
              emptyText="This user is not assigned to any groups"
              data={groups}
              columns={[
                {
                  key: "groupName",
                  title: "Group name",
                  render: ({ name, id }) => (
                    <Button
                      component={RouterLink}
                      to={`/companies/${id}`}
                      variant="text"
                    >
                      <span
                        className={clsx(classes.ellipsis, classes.customText)}
                      >
                        {name || "-"}
                      </span>
                    </Button>
                  )
                },
                {
                  key: "externalId",
                  title: "Group id",
                  render: ({ externalId }) => (
                    <span
                      className={clsx(classes.ellipsis, classes.customText)}
                    >
                      {externalId || "-"}
                    </span>
                  )
                }
              ]}
            />
          </ResponsiveTableWrapper>

          {meta && meta.total > 0 && (
            <Pagination
              totalCount={meta.total}
              onChange={listFilters.setPagination}
              rowsPerPage={listFilters.pagination.rowsPerPage}
              page={listFilters.pagination.page}
            />
          )}
        </>
      )}
    </>
  );
};

export default GroupList;
